export const isNumber = (item: string): boolean => !isNaN(Number(item));
